import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Guide } from 'src/app/models';
import { TranslateService } from '@ngx-translate/core';
import { TestService } from 'src/app/services/test.service';



@Component({
  selector: 'app-guide',
  templateUrl: './guide.component.html',
  styleUrls: ['./guide.component.scss'],
})
export class GuideComponent implements OnInit {
  @Input() guide: Guide;

  constructor(
    private testService: TestService,
    public modalController: ModalController,
    private translate: TranslateService,
  ) { }

  ngOnInit() {

    this.testService.testFeathers();
  }

  close() {
    this.modalController.dismiss();
  }
}
